"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
function useResize(handler) {
    react_1.useEffect(function () {
        window.addEventListener("resize", handler);
        return function () { return window.removeEventListener("resize", handler); };
    }, [handler]);
}
exports.useResize = useResize;
//# sourceMappingURL=use-resize.js.map